import { OrganizationListItemDTO } from 'types/organization';
import { organizationUrls } from 'urls';
import TurnRightIcon from 'ui/elements/icons/TurnRightIcon';
import UserIcon from 'ui/elements/icons/UserIcon';
import React from 'react';
import { ActionItem, ActionLinks } from 'pages/Dashboard/manage/ManageCommunity';
import { MobileMargin } from 'ui/views/layouts/BaseLayout';

export default function ManageOrganization({ organization }: { organization: OrganizationListItemDTO }) {
  return (
    <MobileMargin className="u-section-spacing-bottom">
      <ActionLinks>
        <ActionItem to={organizationUrls.view(organization.slug)}>
          <TurnRightIcon className="u-half-spacing-right" fontSize="small" />
          Go to organization
        </ActionItem>
        <ActionItem to={organizationUrls.settings.connections(organization.slug)}>
          <UserIcon className="u-half-spacing-right" fontSize="small" />
          Invite members
        </ActionItem>
      </ActionLinks>
    </MobileMargin>
  );
}
